import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { Container, Box, SubHeader, ParagraphLastChanged } from './CookieStatementContent.styled';
import CookieTable from './components/Table/CookieTable';

const CookieStatementContent = () => {
  const { t } = useTranslation();

  const getLastModifiedText = () => {
    const date = t('cookies.cookie-statement.date-last-modified');
    const str = t('cookies.cookie-statement.content.paragraph-last-changed', { 'date-last-modified': date });
    return str;
  };

  return (
    <Container>
      <Box>
        <SubHeader variant="body2">
          {t('cookies.cookie-statement.content.subheader1')}
        </SubHeader>
        <Typography variant="body2">{t('cookies.cookie-statement.content.paragraph1a')}</Typography>
        <Typography variant="body2">{t('cookies.cookie-statement.content.paragraph1b')}</Typography>

        <SubHeader variant="body2">
          {t('cookies.cookie-statement.content.subheader2')}
        </SubHeader>
        <Typography variant="body2">{t('cookies.cookie-statement.content.paragraph2a')}</Typography>
        <Typography variant="body2">{t('cookies.cookie-statement.content.paragraph2b')}</Typography>

        <SubHeader variant="body2">
          {t('cookies.cookie-statement.content.subheader3')}
        </SubHeader>
        <Typography variant="body2">{t('cookies.cookie-statement.content.paragraph3a')}</Typography>

        <SubHeader variant="body2">
          {t('cookies.cookie-statement.content.subheader4')}
        </SubHeader>
        <Typography variant="body2">{t('cookies.cookie-statement.content.paragraph4a')}</Typography>
        <Typography variant="body2">{t('cookies.cookie-statement.content.paragraph4b')}</Typography>
        <Typography variant="body2">{t('cookies.cookie-statement.content.paragraph4c')}</Typography>

        <SubHeader variant="body2">
          {t('cookies.cookie-statement.content.subheader5')}
        </SubHeader>
        <Typography variant="body2">{t('cookies.cookie-statement.content.paragraph5a')}</Typography>

        <CookieTable cookieType="analytic" />
        <CookieTable cookieType="functional" />

        <SubHeader variant="body2">
          {t('cookies.cookie-statement.content.subheader6')}
        </SubHeader>
        <Typography variant="body2">{t('cookies.cookie-statement.content.paragraph6a')}</Typography>

        <ParagraphLastChanged variant="body2">
          {getLastModifiedText()}
        </ParagraphLastChanged>
      </Box>
    </Container>
  );
};

export default CookieStatementContent;
